import { Database, Migrator } from '../../db/index.js'
import migrations from './migrations/index.js'
import type { DatabaseSchema } from './schema/index.js'

export * from './schema/index.js'

export type AccountDb = Database<DatabaseSchema>

export const getDb = (
  location: string,
  disableWalAutoCheckpoint = false,
): AccountDb => {
  const pragmas: Record<string, string> = disableWalAutoCheckpoint
    ? { wal_autocheckpoint: '0' }
    : {}
  return Database.sqlite(location, { pragmas })
}

export const getMigrator = (db: AccountDb) => {
  return new Migrator(db.db, migrations)
}
